import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "react-bootstrap/Spinner";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import Select from "react-select";
import { HslStringColorPicker } from "react-colorful";
import { customStylesSelect } from "../customStyleSelect";
import {
  errorEdit,
  successEdit,
  loadingEdit,
} from "../../../redux/slices/status.slice";
import { modalEdit } from "../../../redux/slices/modal.slice";
import { selectAll as selectAllStyles } from "../../../redux/slices/styles.slice";
import { selectAll as selectAllLevels } from "../../../redux/slices/levels.slice";
import styles from "./index.module.scss";
import { getTimeOptionsTeacher, getDefaultTimeValue } from "../options";
import { naturalCompare } from "../../../utilities";

const DEFAULT_COLOR = "hsl(175, 90%, 75%)";

export const week = [
  { label: "Mon", value: "Monday" },
  { label: "Tue", value: "Tuesday" },
  { label: "Wed", value: "Wednesday" },
  { label: "Thu", value: "Thursday" },
  { label: "Fri", value: "Friday" },
  { label: "Sat", value: "Saturday" },
  { label: "Sun", value: "Sunday" },
];

export function Availability({
  count,
  setValue,
  defaultValue,
  options,
  activeDays,
  editDay,
}) {
  const [chosenDay, setChoseDay] = useState(
    defaultValue?.day ? defaultValue?.day.index : null
  );
  const [defaultStartTime, defaultEndTime] = defaultValue
    ? getDefaultTimeValue(
        defaultValue.beginTime,
        defaultValue.finishTime,
        options
      )
    : [null, null];
  const customStylesSelect = {
    control: (base) => ({
      ...base,
      minHeight: 50,
      border: "1px solid #D9D9D9",
      borderRadius: "10px",
      background: "#F9F9FC",
      marginBottom: 10,
      width: "180px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: 4,
    }),
    valueContainer: (base) => ({
      ...base,
      padding: "0px 6px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),
  };

  return (
    <div className={styles.wrapperAvailability}>
      {editDay ? (
        <>
          <label>Availability</label>
          <div className={styles.availability}>
            <input
              type="button"
              value={week[chosenDay]["label"]}
              className={styles.activeDay}
              disabled
            />
          </div>
        </>
      ) : (
        <>
          <label>Availability</label>
          <div className={styles.availability}>
            {week.map((item, i) => {
              if (activeDays?.includes(item.value)) {
                return;
              }
              return (
                <input
                  key={i}
                  type="button"
                  value={item.label}
                  className={chosenDay === i ? styles.activeDay : null}
                  onClick={() => {
                    if (chosenDay === i) {
                      setValue(`availability.${count}.day`, null);
                      setChoseDay(null);
                    } else {
                      setValue(`availability.${count}.day`, {
                        value: item.value,
                        index: i,
                      });
                      setChoseDay(i);
                    }
                  }}
                />
              );
            })}
          </div>
        </>
      )}
      <label>Time</label>
      <div className={styles.time}>
        <Select
          onChange={(choice) => {
            setValue(`availability.${count}.beginTime`, choice.value);
          }}
          styles={customStylesSelect}
          name="beginTime"
          options={options}
          menuPlacement="top"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          defaultValue={defaultStartTime}
          maxMenuHeight={220}
        />
        <div className={styles.timeItem}></div>
        <Select
          onChange={(choice) => {
            setValue(`availability.${count}.finishTime`, choice.value);
          }}
          styles={customStylesSelect}
          name="finishTime"
          options={options}
          menuPlacement="top"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          defaultValue={defaultEndTime}
          maxMenuHeight={220}
        />
      </div>
    </div>
  );
}

function TeacherForm(props) {
  const { chosenTeacher } = useSelector((state) => state.teachers);
  const dispatch = useDispatch();
  const { loading, error, success } = useSelector((state) => state.status);
  const allStyles = useSelector(selectAllStyles);
  const allLevels = useSelector(selectAllLevels);
  const { id, isAdmin } = useSelector((state) => state.personality.user);
  const { chosenUser } = useSelector((state) => state.users);

  const [clickDeletItem, setClickDeletItem] = useState(false);
  const [action, setAction] = useState("TEACHER_ADD_ONE");
  const [colorHex, setColorHex] = useState(
    chosenTeacher?.teacherColor || DEFAULT_COLOR
  );
  const [errorColor, setErrorColor] = useState(null);

  const getDefailtValue = () => {
    let count = 0;
    let defaultValueElement = [];
    if (chosenTeacher?.availabilityTime) {
      chosenTeacher.availabilityTime.forEach((item) => {
        const day = Object.keys(item)[0];
        const values = item[day];
        values.forEach((element) => {
          defaultValueElement.push({
            day: {
              value: day,
              index: week.findIndex((d) => d.value === day),
            },
            beginTime: element.start,
            finishTime: element.end,
          });
          count++;
        });
      });
    } else {
      count = 1;
      defaultValueElement = [];
    }
    return [count, defaultValueElement];
  };

  const options = getTimeOptionsTeacher();
  const [count, defaultValueElement] = getDefailtValue();
  const [countAvailabilityTeacher, setCountAvailabilityTeacher] =
    useState(count);
  const [defaultValue, setDefaultValue] = useState(defaultValueElement);

  const objectYup = {
    teacherName: yup
      .string()
      .required("This field is required")
      .min(2, "Name is too short - should be 2 chars minimum."),
    availability: yup
      .array()
      .required("This field is required")
      .test(
        "optionality",
        "Fields are required or incorrect",
        function (value) {
          let result = true;
          let message = "";
          const { path, createError } = this;
          for (let i = 0; i < value.length; i++) {
            if (value[i] === null) break;
            const { day, beginTime, finishTime } = value[i];
            if (day) {
              if ((beginTime && !finishTime) || (!beginTime && finishTime)) {
                result = false;
                message = "Choose start and end time";
                break;
              }
              if (beginTime > finishTime) {
                result = false;
                message = "Choose correct time";
                break;
              }
              if (!beginTime && !finishTime) {
                setValue(`availability.${i}`, {
                  ...value[i],
                  beginTime: "00:00:00",
                  finishTime: "23:00:00",
                });
              }
            } else if (beginTime || finishTime) {
              result = false;
              message = "Choose day";
              break;
            }
          }
          return result || createError({ path, message });
        }
      ),
  };

  const getStylesOptions = () =>
    allStyles
      .map((item) => ({ value: item.id, label: item.styleName }))
      .sort((a, b) => naturalCompare(a.label, b.label));

  const getDefaultOptions = () =>
    chosenTeacher
      ? chosenTeacher.teacherAndstyles?.map((item) => ({
          value: item.styleId,
          label: item.style.styleName,
        })) || []
      : [];

  const getLevelsOptions = () =>
    allLevels
      .map((item) => ({ value: item.id, label: item.levelName }))
      .sort((a, b) => naturalCompare(a.label, b.label));

  const getDefaultLevelOptions = () =>
    chosenTeacher
      ? chosenTeacher.teacherAndlevels?.map((item) => ({
          value: item.levelId,
          label: item.level.levelName,
        })) || []
      : [];

  const schema = yup.object(objectYup).required();
  const {
    register,
    handleSubmit,
    formState: { errors },
    clearErrors,
    reset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      teacherName: chosenTeacher?.teacherName || "",
      availability: defaultValue,
      styles: getDefaultOptions(),
      levels: getDefaultLevelOptions(),
    },
  });

  useEffect(() => {
    if (chosenTeacher) {
      const [newCount, newDefaults] = getDefailtValue();
      reset({
        teacherName: chosenTeacher.teacherName || "",
        availability: newDefaults,
        styles: getDefaultOptions(),
        levels: getDefaultLevelOptions(),
      });
      setColorHex(chosenTeacher.teacherColor || DEFAULT_COLOR);
      setCountAvailabilityTeacher(newCount);
    }
  }, [chosenTeacher, reset]);

  useEffect(() => {
    return () => {
      clearErrors();
      dispatch(successEdit(null));
      dispatch(errorEdit(null));
      dispatch(loadingEdit(false));
      setErrorColor(null);
    };
  }, []);

  useEffect(() => {
    if (success && !error) {
      reset();
      setCountAvailabilityTeacher(count);
      setColorHex(chosenTeacher?.teacherColor || DEFAULT_COLOR);
    }
  }, [success, error, chosenTeacher?.teacherColor, reset, count]);

  const getListAvailability = () => {
    const list = [];
    for (let i = 0; i < countAvailabilityTeacher; i++) {
      list.push(
        <Availability
          key={i}
          count={i}
          getValues={getValues}
          setValue={setValue}
          errors={errors}
          defaultValue={defaultValue[i] || null}
          options={options}
        />
      );
    }
    return list;
  };

  const getAvailabilityTime = (value) => {
    const daysOfWeek = [null, null, null, null, null, null, null];
    value.availability?.forEach((item) => {
      if (!item || !item.day) return;
      const day = item.day.value;
      const index = item.day.index;
      if (daysOfWeek[index]) {
        daysOfWeek[index][day].push({
          start: item.beginTime,
          end: item.finishTime,
        });
      } else {
        daysOfWeek[index] = {
          [day]: [{ start: item.beginTime, end: item.finishTime }],
        };
      }
    });
    return daysOfWeek.filter(Boolean);
  };

  const onSubmit = (value) => {
    if (!value.teacherName || value.teacherName.trim() === "") {
      return;
    }

    if (!colorHex) {
      setErrorColor("This field is required");
      return;
    }

    setErrorColor(null);
    dispatch(successEdit(null));
    dispatch(errorEdit(null));
    dispatch(loadingEdit(false));

    if (action === "TEACHER_REMOVE_ONE" && !clickDeletItem) {
      setClickDeletItem(true);
      return;
    }

    const stylesId = value.styles?.map((item) => item.value) || [];
    const levelsId = value.levels?.map((item) => item.value) || [];

    const payload = {
      teacherName: value.teacherName.trim(),
      stylesId,
      levelsId,
      teacherId: chosenTeacher?.id || "",
      userId: isAdmin ? chosenUser.id : id,
      availabilityTime:
        value.availability?.length > 0 ? getAvailabilityTime(value) : null,
      teacherColor: colorHex,
    };

    dispatch({ type: action, payload });
  };

  return (
    <>
      {loading ? (
        <div className={styles.spinnerWrapper}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <>
          {clickDeletItem && (
            <div className={styles.confirm}>
              Are you sure you want to delete this Teacher?
            </div>
          )}
          <form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
            {!clickDeletItem && (
              <>
                <div className={styles.formAnswer}>
                  {error && <div className="text-danger">{error}</div>}
                </div>
                <label>Name</label>
                <input
                  {...register("teacherName")}
                  defaultValue={chosenTeacher?.teacherName || ""}
                />
                {errors.teacherName && (
                  <div className={styles.formAnswer}>
                    <div className="text-danger">
                      {errors.teacherName.message}
                    </div>
                  </div>
                )}

                {allStyles.length > 0 ? (
                  <>
                    <label>Styles</label>
                    <Controller
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          onChange={onChange}
                          onBlur={onBlur}
                          selected={value}
                          styles={customStylesSelect}
                          defaultValue={getDefaultOptions()}
                          isMulti
                          name="styles"
                          options={getStylesOptions()}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          menuPlacement="top"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      )}
                      control={control}
                      name="styles"
                      defaultValue={getDefaultOptions()}
                      className="overflow-y-scroll"
                    />
                  </>
                ) : (
                  <div className={styles.add}>
                    <label>No Styles Created</label>
                    <div onClick={() => dispatch(modalEdit("Styles"))}>
                      Add Style +
                    </div>
                  </div>
                )}

                {allLevels.length > 0 ? (
                  <>
                    <label>Levels</label>
                    <Controller
                      render={({ field: { onChange, onBlur, value, ref } }) => (
                        <Select
                          onChange={onChange}
                          onBlur={onBlur}
                          selected={value}
                          styles={customStylesSelect}
                          defaultValue={getDefaultLevelOptions()}
                          isMulti
                          name="levels"
                          options={getLevelsOptions()}
                          className="basic-multi-select"
                          classNamePrefix="select"
                          menuPlacement="top"
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                        />
                      )}
                      control={control}
                      name="levels"
                      defaultValue={getDefaultLevelOptions()}
                    />
                  </>
                ) : (
                  <div className={styles.add}>
                    <label>No Levels Created</label>
                    <div onClick={() => dispatch(modalEdit("Levels"))}>
                      Add Level +
                    </div>
                  </div>
                )}

                <label>Color</label>
                <div className={styles.colorPicker}>
                  <HslStringColorPicker
                    color={colorHex}
                    onChange={(color) => {
                      setColorHex(color);
                    }}
                  />
                  <div
                    style={{ background: colorHex }}
                    className={styles.color}
                  />
                </div>
                {errorColor && (
                  <div className={styles.formAnswer}>
                    <div className="text-danger">{errorColor}</div>
                  </div>
                )}

                {getListAvailability()}

                {errors.availability && (
                  <div className={styles.formAnswer}>
                    <div className="text-danger">
                      {errors.availability.message}
                    </div>
                  </div>
                )}

                <div className={styles.availabilityFooter}>
                  <div
                    onClick={() =>
                      setCountAvailabilityTeacher((count) => count + 1)
                    }
                    className={styles.addText}
                  >
                    Add Time +
                  </div>
                  {countAvailabilityTeacher > 1 && (
                    <div
                      onClick={() => {
                        setValue(
                          `availability.${countAvailabilityTeacher - 1}`,
                          null
                        );
                        setCountAvailabilityTeacher((count) => count - 1);
                      }}
                      className={styles.deleteText}
                    >
                      Delete Time -
                    </div>
                  )}
                </div>
              </>
            )}

            {!chosenTeacher ? (
              <input
                type="submit"
                className={styles.submit}
                value="Save"
                onClick={() => setAction("TEACHER_ADD_ONE")}
              />
            ) : (
              <div className={styles.buttons}>
                {clickDeletItem ? (
                  <>
                    <button
                      className={styles.submitUpdate}
                      onClick={() => setClickDeletItem(false)}
                    >
                      No
                    </button>
                    <input
                      type="submit"
                      className={styles.submitDelete}
                      value="Yes"
                    />
                  </>
                ) : (
                  <>
                    <input
                      type="submit"
                      className={styles.submitDelete}
                      value="Delete"
                      onClick={() => setAction("TEACHER_REMOVE_ONE")}
                    />
                    <input
                      type="submit"
                      className={styles.submitUpdate}
                      value="Save"
                      onClick={() => setAction("TEACHER_UPDATE_ONE")}
                    />
                  </>
                )}
              </div>
            )}
          </form>
        </>
      )}
    </>
  );
}

export default TeacherForm;
